<template>
  <div class="tw-flex tw-flex-col tw-gap-2.5">
    <div
      :class="`tw-flex tw-flex-col tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded ${className}`"
    >
      <slot />
    </div>
    <div class="tw-flex tw-flex-1 tw-gap-5 tw-items-center tw-justify-end">
      <button
        v-if="hasDetail"
        class="tw-text-[12px] tw-font-normal tw-text-[#387DFF]"
        @click="$emit('update:show-detail')"
      >
        {{
          isShowDetail
            ? getComponentUiText(
                "app-scan-scanning-types-table-results-body-cell-unexpected-hide-details-1",
              )
            : getComponentUiText(
                "app-scan-scanning-types-table-results-body-cell-unexpected-more-details-1",
              )
        }}
      </button>
      <b-button
        v-if="hasIgnore"
        :style="{
          width: `fit-content`,
        }"
        variant="primary"
        class="tw-min-w-max tw-flex tw-items-center tw-justify-center tw-shadow-none tw-bg-white tw-text-[12px] tw-font-normal tw-text-[#387DFF] tw-border tw-border-solid tw-border-[#EFF0F1] tw-rounded-full tw-px-3 tw-py-1"
        @click="$emit('update:ignore', type)"
      >
        {{
          getComponentUiText(
            type === SCANNING_TABLE_RESULT_ITEM_TYPE.ignore
              ? "app-scan-scanning-types-table-results-body-cell-unexpected-ignore-1"
              : "app-scan-scanning-types-table-results-body-cell-unexpected-include-1",
          )
        }}
      </b-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponentUiText } from "@/utils/utilities";
import { SCANNING_TABLE_RESULT_ITEM_TYPE } from "@/utils/constants";

defineProps<{
  isShowDetail?: boolean;
  hasDetail?: boolean;
  hasIgnore?: boolean;
  type?: keyof typeof SCANNING_TABLE_RESULT_ITEM_TYPE;
  className?: string;
}>();

defineEmits<{
  (e: "update:show-detail"): void;
  (
    e: "update:ignore",
    type?: keyof typeof SCANNING_TABLE_RESULT_ITEM_TYPE,
  ): void;
}>();
</script>
